import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";
import {notificationDeleteSuccess} from "store/reducer/notifications/delete/reducer";


export const initialState = {
    status : ReducerStatuses.IDLE,
    error: "",
    list: [],
    current_page: 1,
    has_next_page: false
}

const slice = createSlice({
    name: "notificationList",
    initialState,
    reducers: {
        notificationListStart: (state) => {
            state.status = ReducerStatuses.LOADING;
            state.error = initialState.error;
            state.current_page = 1;
        },
        notificationListError: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        notificationListSuccess: (state, {payload}) => {
            state.status = ReducerStatuses.SUCCESS;
            state.error = initialState.error;
            if(state.current_page === 1) {
                state.list = payload.notifications;
            } else {
                state.list = state.list.concat(payload.notifications);
            }
            state.has_next_page = payload.hasNextPage;
        },
        notificationListFetchNextPage: (state) => {
            state.current_page = state.current_page + 1;
            state.status = ReducerStatuses.LOADING;
        }
    },
    extraReducers: {
        [notificationDeleteSuccess]: (state) => {
            state.list = [];
            state.current_page = 1;
        }
    }
});

const {actions, reducer} = slice;
export const {
    notificationListError, notificationListStart, notificationListSuccess, notificationListFetchNextPage
} = actions;
export default reducer;